// removed by extract-text-webpack-plugin
module.exports = {"FareRulesDetails":"_KTuhk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/Tuple/TupleInner/FareInfo/FareRules/FareRules.scss
// module id = 522
// module chunks = 0